import styled from 'styled-components';

export const Container = styled.div<{$focused?: boolean}>`
    min-width: 16rem;
    min-height: 10.5rem;
    margin: 0 1rem 1rem 1rem;
    padding: 15px;
    background-color: #1d1c1f;
    border-radius: 10px;
    border: ${({$focused}) => ($focused ? '2px solid #007bA1' : '2px solid transparent')};
    transition: border 0.2s ease;
`;

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -8px;
    flex: 1;
`;

interface ICol {
    size: number;
}

export const Col = styled.div<ICol>`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    flex: 0 0 ${(props) => (props.size / 12) * 100}%;
    max-width: ${(props) => (props.size / 12) * 100}%;
    @media (max-width: 768px) {
        flex: 0 0 100%;
        max-width: 100%;
    }
    height: 80px;
`;

export const DateTimeText = styled.div`
    font-size: 1.3rem;
`;
